import { useState } from 'react';
import { useReportDateRange } from '@/hooks/useReportDateRange';
import { reportsApi } from '@/services/api';
import { downloadCsv } from '@/utils/csv';
import PurchaseReportFilters from '../shared/PurchaseReportFilters';
import ReportDataTable, { columnsToCsvHeaders, rowsToCsvData } from '../shared/ReportDataTable';
import ReportLayout from '../shared/ReportLayout';
import { fetchPurchaseReportExport, usePurchaseReport } from '../shared/usePurchaseReport';
import { activitySupplierColumns, ActivitySupplierRow } from './columns';

export default function PurchaseActivitySupplierPage() {
  const dateRangeHook = useReportDateRange('This Month');
  const { from_date, to_date } = dateRangeHook;
  const [supplier, setSupplier] = useState('');
  const [supplierLabel, setSupplierLabel] = useState('');

  const params = { from_date, to_date, supplier: supplier || undefined };

  const { rows, total, page, setPage, pageSize, isLoading } = usePurchaseReport({
    queryKey: 'purchaseActivitySupplier',
    params,
    fetcher: (p) => reportsApi.getPurchaseActivitySupplier(p),
  });

  const handleExport = async () => {
    const data = await fetchPurchaseReportExport(reportsApi.getPurchaseActivitySupplier, params);
    downloadCsv(
      `purchase-activity-supplier-${from_date}-${to_date}.csv`,
      columnsToCsvHeaders(activitySupplierColumns),
      rowsToCsvData(data.rows as unknown as ActivitySupplierRow[], activitySupplierColumns),
    );
  };

  return (
    <ReportLayout
      onExport={handleExport}
      exportDisabled={!total}
      isLoading={isLoading}
      isEmpty={!rows.length}
      page={page}
      total={total}
      pageSize={pageSize}
      onPageChange={setPage}
      filters={
        <PurchaseReportFilters
          dateRangeHook={dateRangeHook}
          supplier={supplier}
          supplierLabel={supplierLabel}
          onSupplierChange={(id, label) => {
            setSupplier(id);
            setSupplierLabel(label);
          }}
        />
      }
    >
      <ReportDataTable data={rows as never[]} columns={activitySupplierColumns} />
    </ReportLayout>
  );
}
